import React from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { shallowEqual } from 'react-redux';
import useFetch from 'src/hooks/useFetch';
import { fetchDetails } from 'src/redux/action/details.action';
import { RootState } from 'src/redux/reducers';
import { CiLock } from 'react-icons/ci';

interface IProps {
  activeIndex: number;
  setActiveIndex: (idx: number) => void;
  tabData: { label: string; id: number; lock?: boolean }[];
}
const Tab: React.FC<IProps> = ({ setActiveIndex, activeIndex, tabData }) => {
  const dispatch = useDispatch();

  const handleClick = (index: number) => {
    setActiveIndex(index);
    dispatch(fetchDetails() as any);
  };
  const checkActive = (index: number, className: string) =>
    activeIndex === index ? 'bg-[#D9E0FF]' : '';
  return (
    <>
      <div className="rounded-xl border border-border-color-dark ">
        {tabData.map((item) => (
          <h6
            className={` border-b-0   rounded-xl rounded-r-none rounded-l-none last:border-b-[1px] border  font-normal cursor-pointer border-border-color first:rounded-t-xl last:rounded-b-xl hover:bg-[#D9E0FF] 
            ${checkActive(item?.id, '')} 
          px-7 py-3 
          ${item?.lock && 'text-light-gray flex items-center'}
          `}
            onClick={() => !item?.lock && handleClick(item?.id)}
            key={item?.id}
          >
            {item?.label}
            <CiLock size={16} className={`ml-2 ${!item?.lock && 'hidden'}`} />
          </h6>
        ))}
      </div>
    </>
  );
};

export default React.memo(Tab);
